import { RegionsList, RegionsCreate, RegionsEdit, RegionsShow } from './views';

export default {
  show: RegionsShow,
  create: RegionsCreate,
  edit: RegionsEdit,
  list: RegionsList,
  name: 'region',
  label: 'Regions',
  to: '/region',
};
